module.exports = __webpack_public_path__ + "static/media/icon-tick.f7f7648c.svg";